import * as React from "react";
import axios from 'axios';
import { useState, useEffect, useRef, useCallback } from 'react';
import "../css/inspection.css";
import {
    GoogleMap,
    LoadScript,
    Marker,
    StandaloneSearchBox
  } from '@react-google-maps/api';

const ImageUpload = ({ className, file }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [responseText, setResponseText] = useState("No File Uploaded.");
    const canvasRef = useRef(null);
    const videoRef = useRef(null);
    const apiKey = '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';
    const assistantId = 'asst_sbUz4gcRzoEdcLHUJiPVXMYX';
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${apiKey}`,
        'OpenAI-Beta': 'assistants=v2',  
    };
    const delay = (ms) => {
        return new Promise(resolve => setTimeout(resolve, ms));
    };

    const calculateDistance = (lat1, lng1, lat2, lng2) => {
        const toRad = (deg) => deg * (Math.PI / 180);
        const R = 6371000; 
        const dLat = toRad(lat2 - lat1);
        const dLng = toRad(lng2 - lng1);
        const a =
          Math.sin(dLat / 2) ** 2 +
          Math.cos(toRad(lat1)) *
            Math.cos(toRad(lat2)) *
            Math.sin(dLng / 2) ** 2;
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
      };

    const libraries = ['places'];

const containerStyle = {
  width: '100%',
  height: '500px',
};

const defaultCenter = {
  lat: 34.0689,
  lng: -118.4452,
};

const SearchableMap = () => {
    const mapRef = useRef(null);
    const searchBoxRef = useRef(null);
  
    const [marker1, setMarker1] = useState(defaultCenter);
    const [marker2, setMarker2] = useState({
      lat: defaultCenter.lat,
      lng: defaultCenter.lng + 0.001, 
    });
  
    const [distance, setDistance] = useState(0);
  
    const updateDistance = useCallback(() => {
      const d = calculateDistance(
        marker1.lat,
        marker1.lng,
        marker2.lat,
        marker2.lng
      );
      setDistance(d.toFixed(2));
    }, [marker1, marker2]);
  
    useEffect(() => {
      updateDistance();
    }, [marker1, marker2, updateDistance]);
  
    const handleDrag1 = (e) => {
      setMarker1({ lat: e.latLng.lat(), lng: e.latLng.lng() });
    };
  
    const handleDrag2 = (e) => {
      setMarker2({ lat: e.latLng.lat(), lng: e.latLng.lng() });
    };
  
    return (
      <LoadScript
        googleMapsApiKey={"AIzaSyB1RjZ1pcV1V2OejC8yrlWWwdBXH79XT_s"}
        libraries={libraries}
      >
        <div style={{ marginBottom: '10px' }}>
          <StandaloneSearchBox
            onLoad={(ref) => (searchBoxRef.current = ref)}
            onPlacesChanged={() => {
              const places = searchBoxRef.current.getPlaces();
              if (places.length > 0) {
                const location = places[0].geometry.location;
                const newCenter = {
                  lat: location.lat(),
                  lng: location.lng(),
                };
                setMarker1(newCenter);
                setMarker2({ lat: newCenter.lat, lng: newCenter.lng + 0.001 });
                mapRef.current.panTo(newCenter);
              }
            }}
          >
            <input
              type="text"
              placeholder="Search a location"
              style={{
                width: '100%',
                height: '40px',
                padding: '0 12px',
                fontSize: '16px',
              }}
            />
          </StandaloneSearchBox>
        </div>
  
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={marker1}
          zoom={18}
          onLoad={(map) => (mapRef.current = map)}
        >
          <Marker
            position={marker1}
            draggable={true}
            onDragEnd={handleDrag1}
            label="A"
          />
          <Marker
            position={marker2}
            draggable={true}
            onDragEnd={handleDrag2}
            label="B"
          />
        </GoogleMap>
  
        <div style={{ marginTop: '20px', fontWeight: 'bold', fontSize: '18px' }}>
            Distance between markers: {distance} meters
        </div>

      </LoadScript>
    );
  };

    const drawPlaceholderImage = () => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        const placeholderImg = new Image();
        placeholderImg.src = require('../images/image.png'); 
        placeholderImg.onload = () => {
            canvas.width = placeholderImg.width;
            canvas.height = placeholderImg.height;
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(placeholderImg, 0, 0);
        };
    };

    const drawImage = (imageFile) => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        if (imageFile && imageFile.type.startsWith('image/')) {
            const reader = new FileReader();
    
            reader.onload = function(e) {
                const img = new Image();
                img.src = e.target.result; 
                img.onload = () => {
                    canvas.width = img.width;
                    canvas.height = img.height;
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    ctx.drawImage(img, 0, 0);
                };
            };
            reader.readAsDataURL(imageFile);
        }
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setSelectedFile(file);
        if (file && file.type.startsWith('image/')) {
            drawImage(file);
        } else if (file && file.type.startsWith('video/')) {
            const videoUrl = URL.createObjectURL(file);  
            videoRef.current.src = videoUrl; 
            videoRef.current.load();
            const videoElement = videoRef.current;
            videoElement.addEventListener('loadedmetadata', () => {
                const duration = videoElement.duration;
                console.log("Video duration is " + duration + " seconds");
                extractFrames(duration)
            });
        }
    };

    const extractFrames = async (duration) => {
        const videoElement = videoRef.current;
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        const frameCount = 9;  
        const framesArray = [];
        const interval = duration / frameCount;  
        let currentTime = 0;
        const frameIDsArray = [];  
    
        console.log("start extracting");
    
        const captureFrame = async (i) => {
            if (i >= frameCount) {
                console.log('All 9 frames have been uploaded!', frameIDsArray);
                handleSubmitNine(frameIDsArray); 
                return; 
            }
            videoElement.currentTime = currentTime;
            videoElement.addEventListener('seeked', async function handleSeek() {
                ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
                const dataURL = canvas.toDataURL('image/png');
                framesArray.push(dataURL);
                const blob = await fetch(dataURL).then(res => res.blob());
                const file = new File([blob], `frame_${i}.png`, { type: 'image/png' });
                const fileId = await uploadImage(file);
                if (fileId) {
                    frameIDsArray.push(fileId);  
                }
                currentTime += interval;
                captureFrame(i + 1);
                videoElement.removeEventListener('seeked', handleSeek);
            });
        };
        captureFrame(0);
    };
    

    useEffect(() => {
        drawPlaceholderImage();
    }, [])

    useEffect(() => {
        if (selectedFile) {
            handleSubmitOne();
        }
    }, [selectedFile]);  
    
    async function uploadImage(selectedFile) {
        try {
            const formData = new FormData();
            formData.append('file', selectedFile);  
            formData.append('purpose', 'vision'); 
            const uploadResponse = await axios.post(
                'https://api.openai.com/v1/files',
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${apiKey}` 
                    }
                }
            );
    
            const fileId = uploadResponse.data.id;  
            console.log('Uploaded File ID:', fileId);
            return fileId;
        } catch (error) {
            console.error('Error uploading the file:', error.response ? error.response.data : error.message);
            return null; 
        }
    }
    
    const handleSubmitOne = async () => {
        setResponseText("Loading...");
        if (!selectedFile) {
            console.log("No file selected");
            return;
        }
        const fileId = await uploadImage(selectedFile);  
        if (!fileId) {
            setResponseText('Image upload failed.');
            return;  
        }

        const requestData = {
            assistant_id: assistantId,  
            thread: {
                messages: [
                    {
                        role: 'user',  
                        content: [
                            {
                                "type": "image_file",
                                "image_file": {
                                    "file_id": fileId  
                                }
                            },
                            {
                                "type": "text",
                                "text": "Analyze the following image and provide detailed, point-by-point observations on these aspects:\n\n1. Surface Condition – Describe pavement features such as cracks, potholes, or general wear. Rate the overall surface condition as poor, fair, or good.\n2. Roadside Features – Identify curbs, sidewalks, drainage systems, signage, guardrails, or bike lanes.\n3. Road Width & Capacity – Comment on lane width, whether the road supports two-way traffic, and the ability to accommodate emergency or service vehicles. Note any bottlenecks.\n4. Potential Hazards – Look for risks such as erosion, slope instability, debris, or insufficient safety infrastructure like guardrails.\n5. Roadside Vegetation – Highlight any overgrowth, obstructed visibility, or vegetation that could pose hazards.\n6. Recommended Improvements – Suggest possible upgrades to enhance safety, flow, or durability, such as resurfacing, widening, or drainage fixes.\n\nDo not include introductory or concluding remarks. Start directly with the analysis points."
                            }                              
                        ]
                    }
                ]
            }
        };
    
        try {
            const response = await axios.post(
                'https://api.openai.com/v1/threads/runs',
                requestData,
                { headers: headers }
            );
    
            const threadId = response.data.thread_id;
            const runId = response.data.id;
            let runResponse = await axios.get(
                `https://api.openai.com/v1/threads/${threadId}/runs/${runId}`,
                {
                    headers: headers,
                }
            );
    
            while (runResponse.data.status !== "completed") {
                runResponse = await axios.get(
                    `https://api.openai.com/v1/threads/${threadId}/runs/${runId}`,
                    {
                        headers: headers,
                    }
                );
                await delay(1000);  
            }
    
            const messageResponse = await axios.get(`https://api.openai.com/v1/threads/${threadId}/messages`, {
                headers: headers
            });

            if (messageResponse.data && messageResponse.data.data[0] && messageResponse.data.data[0].content[0].text) {
                const finalResponse = messageResponse.data.data[0].content[0].text.value;
                setResponseText(finalResponse);
            } else {
                console.error('Unexpected response structure:', messageResponse.data);
                setResponseText('Unexpected response structure from the assistant.');
            }
    
        } catch (error) {
            console.error('Error calling the OpenAI API:', error.response ? error.response.data : error.message);
            setResponseText('An error occurred while processing your request.');
        }
    };

    const handleSubmitNine = async (frameIDsArray) => {
        setResponseText("Loading...");
        console.log("Submitting Nine");
        const requestData = {
            assistant_id: assistantId,  
            thread: {
                messages: [
                    {
                        role: 'user',  
                        content: [
                            {
                                "type": "text",
                                "text": "Analyze the following images all belonging to the same road and provide detailed, point-by-point observations on these aspects:\n\n1. Surface Condition – Describe pavement features such as cracks, potholes, or general wear. Rate the overall surface condition as poor, fair, or good.\n2. Roadside Features – Identify curbs, sidewalks, drainage systems, signage, guardrails, or bike lanes.\n3. Road Width & Capacity – Comment on lane width, whether the road supports two-way traffic, and the ability to accommodate emergency or service vehicles. Note any bottlenecks.\n4. Potential Hazards – Look for risks such as erosion, slope instability, debris, or insufficient safety infrastructure like guardrails.\n5. Roadside Vegetation – Highlight any overgrowth, obstructed visibility, or vegetation that could pose hazards.\n6. Recommended Improvements – Suggest possible upgrades to enhance safety, flow, or durability, such as resurfacing, widening, or drainage fixes.\n\nDo not include introductory or concluding remarks. Start directly with the analysis points."
                            },
                            {
                                "type": "image_file",
                                "image_file": {
                                    "file_id": frameIDsArray[0]  
                                }
                            },
                            {
                                "type": "image_file",
                                "image_file": {
                                    "file_id": frameIDsArray[1] 
                                }
                            },
                            {
                                "type": "image_file",
                                "image_file": {
                                    "file_id": frameIDsArray[2] 
                                }
                            },
                            {
                                "type": "image_file",
                                "image_file": {
                                    "file_id": frameIDsArray[3]  
                                }
                            },
                            {
                                "type": "image_file",
                                "image_file": {
                                    "file_id": frameIDsArray[4] 
                                }
                            },
                            {
                                "type": "image_file",
                                "image_file": {
                                    "file_id": frameIDsArray[5] 
                                }
                            },
                            {
                                "type": "image_file",
                                "image_file": {
                                    "file_id": frameIDsArray[6] 
                                }
                            },
                            {
                                "type": "image_file",
                                "image_file": {
                                    "file_id": frameIDsArray[7] 
                                }
                            },
                            {
                                "type": "image_file",
                                "image_file": {
                                    "file_id": frameIDsArray[8] 
                                }
                            },
                        ]
                    }
                ]
            }
        };
    
        try {
            const response = await axios.post(
                'https://api.openai.com/v1/threads/runs',
                requestData,
                { headers: headers }
            );
    
            const threadId = response.data.thread_id;
            const runId = response.data.id;
            let runResponse = await axios.get(
                `https://api.openai.com/v1/threads/${threadId}/runs/${runId}`,
                {
                    headers: headers,
                }
            );
    
            while (runResponse.data.status !== "completed") {
                runResponse = await axios.get(
                    `https://api.openai.com/v1/threads/${threadId}/runs/${runId}`,
                    {
                        headers: headers,
                    }
                );
                await delay(1000);  

            }
            const messageResponse = await axios.get(`https://api.openai.com/v1/threads/${threadId}/messages`, {
                headers: headers
            });
            if (messageResponse.data && messageResponse.data.data[0] && messageResponse.data.data[0].content[0].text) {
                const finalResponse = messageResponse.data.data[0].content[0].text.value;
                setResponseText(finalResponse);
            } else {
                console.error('Unexpected response structure:', messageResponse.data);
                setResponseText('Unexpected response structure from the assistant.');
            }
    
        } catch (error) {
            console.error('Error calling the OpenAI API:', error.response ? error.response.data : error.message);
            setResponseText('An error occurred while processing your request.');
        }
    };
    
    return (
<div className="application">
  <div className="title">
    <h1>Road Image Analyzer</h1>
    <div className="analysis">
      <strong>Analysis:</strong> {responseText}
    </div>
  </div>

  <div className="side-by-side">
    <div className="placeholder">
      <canvas ref={canvasRef} className="preview-image" />
      <video
        ref={videoRef}
        width="600"
        height="338"
        style={{ display: 'none', margin: '0 auto' }}
      ></video>
      <div className="width-input-group">
        <input
          type="number"
          id="manualWidth"
          className="width-input"
          placeholder="Enter Width Here"
          step="0.01"
        />
      </div>
    </div>

    <div className="map-panel">
      <SearchableMap />
    </div>
  </div>
  <div className="upload-button-container">
    <input
      type="file"
      id="fileUpload"
      onChange={handleFileChange}
      style={{ display: 'none' }}
    />
    <label htmlFor="fileUpload" className="upload-button">
      {selectedFile ? 'Change File' : 'Upload File'}
    </label>
  </div>
</div>
    );
};

export default ImageUpload;
